module.exports = __webpack_public_path__ + "assets/img/xsyl_img.2d51fa9f.png";